module.exports = __webpack_public_path__ + "static/media/share.be8d3c66.svg";